module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-8"
  }, [_c('div', {
    staticClass: "card card-default card-final"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                " + _vm._s(_vm.titulo) + "\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), (_vm.cadastrado.ultimoProtocolo) ? _c('div', {
    staticClass: "row row-field"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cadastrado.anexos.length === 0 &&
        _vm.cadastrado.validacaoPendente === true
      ),
      expression: "cadastrado.anexos.length === 0 &&\n                  cadastrado.validacaoPendente === true\n                  "
    }]
  }, [_vm._v("\n                  Lembre-se de "), _c('strong', [_vm._v("anexar")]), _vm._v(" seus documentos para\n                  "), _c('strong', [_vm._v("validar")]), _vm._v(" a atualização do seu cadastro.\n                ")]), _vm._v(" "), _c('p', [_vm._v("Anote ou imprima o seu número.")]), _vm._v(" "), _c('div', {
    staticClass: "espacado",
    staticStyle: {
      "color": "#004f4a"
    }
  }, [_c('h2', [_vm._v("PROTOCOLO")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cadastrado.ultimoProtocolo.codigo) + "\n                  ")])])]) : _c('div', {
    staticClass: "row row-field"
  }, [_vm._m(1)])])])])])])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin": "40px 15px",
      "padding-bottom": "40px"
    },
    attrs: {
      "role": "controller"
    }
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Imprimir",
      "icone": "fa-print",
      "disabled": !_vm.cadastrado.ultimoProtocolo
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.cadastrado.id, _vm.cadastrado.ultimoProtocolo.id)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  O presente "), _c('strong', [_vm._v("protocolo")]), _vm._v(" serve apenas para\n                  guarda "), _c('strong', [_vm._v("pessoal")]), _vm._v(", não sendo necessário a\n                  entrega em nenhum setor da Prefeitura de Santos.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning espacado",
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Envie sua\n                  atualização cadastral para receber um número de protocolo.\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b12c71ba","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/fim/index.vue
// module id = 8EMK
// module chunks = 5